import {
  computed,
  ref,
  toRef,
} from "vue";

import AHttpAPI from "aloha-vue/src/compositionAPI/AHttpAPI";
import PuxTablePlugin from "../plugin/PuxTablePlugin";

import {
  isNil,
} from "lodash-es";

const optionsLoadingPromises = ref({});

export default function OptionsAPI(props, {
  limit = ref(10),
  modelColumnsVisible = ref({}),
  modelColumnsOrderingLocal = ref([]),
  modelIsTableWithoutScrollStartLocal = ref(true),
}) {
  const isSavingOptions = toRef(props, "isSavingOptions");
  const id = toRef(props, "id");
  const isSimpleTable = toRef(props, "isSimpleTable");

  const {
    getHttp,
    postHttp,
    putHttp,
  } = AHttpAPI();

  const {
    isAuthenticated,
  } = PuxTablePlugin.UserAPI();

  const isLoadingOptionsFirst = ref(true);
  const isLoadingOptions = ref(false);
  const optionsUrl = "nutzertabellenconfigs/";
  const optionsPk = ref(undefined);

  const urlSaveTableOptions = computed(() => {
    if (optionsPk.value) {
      return `${ optionsUrl }${ optionsPk.value }/`;
    }
    return optionsUrl;
  });

  const httpMethodSaveTableOptions = computed(() => {
    return optionsPk.value ? putHttp : postHttp;
  });

  const tableOptionsForSave = computed(() => {
    return {
      pk: optionsPk.value,
      kennung: id.value,
      aloha: {
        count: limit.value,
        compact_view: modelIsTableWithoutScrollStartLocal.value,
        ordering_columns: modelColumnsOrderingLocal.value,
        column_visibility_conf: modelColumnsVisible.value,
      },
    };
  });

  const setTableOptions = response => {
    if (response.length) {
      const CURRENT_OPTIONS = response[0];
      const ALOHA_OPTIONS = CURRENT_OPTIONS.aloha || {};
      optionsPk.value = CURRENT_OPTIONS.pk;
      limit.value = ALOHA_OPTIONS.count || limit.value;
      modelColumnsVisible.value = ALOHA_OPTIONS.column_visibility_conf;
      modelColumnsOrderingLocal.value = ALOHA_OPTIONS.ordering_columns;
      modelIsTableWithoutScrollStartLocal.value = isNil(ALOHA_OPTIONS.compact_view) ? true : ALOHA_OPTIONS.compact_view;
    }
  };

  const loadTableOptions = () => {
    if (!isAuthenticated.value ||
      !isSavingOptions.value ||
      isSimpleTable.value) {
      return Promise.resolve();
    }

    if (!optionsLoadingPromises.value[id.value]) {
      optionsLoadingPromises.value[id.value] = getHttp({
        url: optionsUrl,
        urlParams: {
          ntc_kennung: id.value,
        },
      });
    }

    return optionsLoadingPromises.value[id.value].then(
      response => {
        setTableOptions(response);
      }
    );
  };

  const saveTableOptions = () => {
    if (isSavingOptions.value && isAuthenticated.value) {
      isLoadingOptions.value = true;
      httpMethodSaveTableOptions.value({
        url: urlSaveTableOptions.value,
        data: tableOptionsForSave.value,
      }).then(
        response => {
          optionsPk.value = response.pk;
          isLoadingOptions.value = false;
        }
      );
    }
  };

  const destroyCurrentOptionsLoadingPromises = () => {
    if (optionsLoadingPromises.value[id.value]) {
      delete optionsLoadingPromises.value[id.value];
    }
  };

  return {
    destroyCurrentOptionsLoadingPromises,
    isLoadingOptions,
    isLoadingOptionsFirst,
    loadTableOptions,
    saveTableOptions,
  };
}
